/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Who_To_RegisterInputs */

const fr_household_who_to_register = /** @type {(inputs: Household_Who_To_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui inscrire ?`)
};

/**

* @param {Household_Who_To_RegisterInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_who_to_register = /** @type {((inputs?: Household_Who_To_RegisterInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Who_To_RegisterInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_who_to_register(inputs)
});